<template>
  <es-layout
    custom-class="custom-class"
    custom-main="custom-main"
    layout="{{['header']}}"
    esMainStyle="{{esMainStyle}}"
    navbarTitle=""
    navbarStyle=""
    useDefaultNavbar="{{false}}"
    useBlankPage="{{useBlankPage}}"
    blankImageUrl="{{blankImageUrl}}"
    blankContextTitle="{{blankContextTitle}}"
    blankContextSubTitle="{{blankContextSubTitle}}"
    hasBlankButton="{{hasButton}}"
    blankPageType="blank-page"
    bind:blank-retry="getTrainDetailFunc"
  >
    <view slot="header" wx:style="{{ {background: '#fff'} }}">
      <es-navbar wx:style="{{navbarStyle}}" left-arrow="{{true}}" class="headerStyle" bind:click-left="goBackReport">
        <view class="es-navbar-title" wx:if="{{!fromChangeTicket}}"> 
          <date-card
            wx:ref="date_card"
            value="{{time}}"
            date-type="{{'MM-dd'}}"
            checkType="single"
            linking="{{linking}}"
            isUpdateEveryTime="{{true}}"
            checkRange="{{7}}"
            dateType="M月d日"
            maxDate="{{maxDateTime}}"
            minDate="{{minDateTime}}"
            maxHeaderDate="{{headerMaxDateTime}}"
            minHeaderDate="{{headerMinDateTime}}"
            startText="去程"
            endText="返程"
            title="选择前往日期"
            closeable="{{true}}"
            disable="{{isTransfer || !showTrainInfomation}}"
            bind:confirm="onConfirm"
            bind:handleClickDay="handleClickDay"
            bind:reportClick="dateCardClickReport"
          /> 
      </view>
        <change-navbar process="{{1}}" wx:else />
        <view wx:if="{{!fromChangeTicket}}" slot='right'>
          <view class="es-navbar-right" bindtap="jumpFn">购票须知</view>
        </view>
      </es-navbar>
      <!-- 日期，前一天 后一天 -->
      <!-- <date-card
        wx:ref="date_card"
        value="{{time}}"
        date-type="{{'MM-dd'}}"
        checkType="single"
        linking="{{linking}}"
        isUpdateEveryTime="{{true}}"
        checkRange="{{7}}"
        dateType="M月d日"
        maxDate="{{maxDateTime}}"
        minDate="{{minDateTime}}"
        maxHeaderDate="{{headerMaxDateTime}}"
        minHeaderDate="{{headerMinDateTime}}"
        startText="去程"
        endText="返程"
        title="选择前往日期"
        closeable="{{true}}"
        bind:confirm="onConfirm"
        bind:handleClickDay="handleClickDay"
        bind:reportClick="dateCardClickReport"
      /> -->
    </view>
    <!-- 车次信息 -->
    <view class="train-info" wx:style="{{ {background: '#fff'}}}">
      <train-information-new 
        wx:if="{{!isTransfer}}" 
        noDetail 
        trainInfo="{{trainInfo}}" 
        bind:click="showSSI"
      />
      <view wx:else wx:for="{{trainInfo.transfer_ticket}}"> 
        <train-information-new
          noDetail
          isTransfer
          cardIndex="{{index + 1}}"
          trainInfo="{{item}}"
          bind:click="showSSI"
        />
        <transfer-info-tip 
          wx:if="{{index !== trainInfo.transfer_ticket?.length - 1}}" 
          wx:style="margin: 0 -10px" 
          startStation="{{item?.to_station_name ?? ''}}"
          toStation="{{trainInfo?.transfer_ticket[index + 1]?.from_station_name ?? ''}}"
          stopTime="{{trainInfo.transfer_stop_time}}"
        />
      </view>
    </view>
    <view class="train-detail-container" wx:if="{{showTrainInfomation}}">
      <guide-tips wx:if="{{isPreScramble}}"  pageType="detail" trainInfo="{{trainInfo}}"/> 
      <!-- 座次信息 -->
      <view>
        <seat-information
          wx:for="{{selectSeatInfo}}"
          wx:class="{{selectSeatInfo.length > 1 && 'seat-information'}}"
          isStudent="{{isStudent}}"
          fromChangeTicket="{{fromChangeTicket}}"
          isPreScramble="{{isPreScramble}}"
          selectSeatInfo="{{item}}"
          ticketData="{{ticketData[index]}}"
          seatInfoIndex="{{index}}"
          bind:reportClick="seatInfoClickReport"
          bind:show="openPriceEstimation"
        />
      </view>
      <!-- 预定按钮 buttonType 0普通 1免登 2抢票 3预约抢票-->
      <buy-ticket-card 
        from="{{from}}"    
        buttonType="{{cardType}}" 
        privacyList="{{privacyList}}" 
        trackParams="{{trackParams}}"
        bind:reportClick="buyClickReport" 
        bind:resetPrivacyList="resetPrivacyList"
      />
      <view class="split-line" wx:if="{{showExemption}}"></view>
      <buy-ticket-card 
        wx:if="{{showExemption}}"
        buttonType="{{1}}" 
        from="{{from}}" 
        privacyList="{{privacyList}}"
        trackParams="{{trackParams}}"
        bind:reportClick="buyClickReport" 
        bind:getServiceDescription="getServiceDescription"
        bind:resetPrivacyList="resetPrivacyList"
      />
    </view>
    <view wx:else class="skeleton">
      <view class="skeleton-item">
        <view class="skeleton-1" wx:for="{{3}}"></view>
      </view>
      <view class="skeleton-bottom">
        <view class="skeleton-2"></view>
        <view class="skeleton-3"></view>
        <view class="skeleton-split-line"></view>
        <view class="skeleton-4"></view>
        <view class="skeleton-5"></view>
      </view>
    </view>
  </es-layout>
  <stay-info-drawer
    show="{{ showStayInfo }}"
    title="时刻表"
    isTransfer="{{isTransfer}}"
    stayInfo="{{stayInfo}}"
    stayInfoList="{{stayInfoList}}"
    bind:close="closeSSI"
    bind:setStayInfo="setStayInfo"
  />
  <price-detail-info-alter
    show="{{ showPriceEstimation }}"
    title="{{ priceEstimation.title }}"
    priceDetail="{{ priceEstimation.detail }}" 
    priceDetailCardTip="卧铺价格仅供参考，以实际出票结果收取费用"
    bind:close="closePriceEstimation"
    customStyle="{{lowerDrawer}}"
  />
  <nologin-description show="{{showServiceDescription}}" bind:close="closeServiceDescription"/>
  <es-toast id="es-toast" />
</template>

<style lang="stylus" scoped>
  @import '~@/mixins/stylus/color.styl'

  .custom-class
    // background-image url('https://dpubstatic.udache.com/static/dpubimg/4hnS2tq0TNoruy-zYTC4p.png')
    // background-repeat no-repeat
    // background-position center center
    // background-size cover
    background #f2f6f9
  .es-navbar-title
    font-size 18px
    font-weight 600
    color #000004
  .es-navbar-right
    font-size 14px
    font-weight 400
    color $train-color-333
  .train-info
    padding 0 10px 10px 
  .train-detail-container
    margin 10px
    background #fff
    border-radius 8px
    padding 14px 14px 4.25px 14px
    .split-line
      height 1px
      background #EEEEEE
  .skeleton
    margin 10px
    // width 355px
    height 256px
    background #FFFFFF
    border-radius 8px
    &-item 
      display flex
      padding 14px 0 14px 14px
    &-1
      display flex
      flex-direction row
      width 104px
      height 74px
      border-radius 10px
      background #E4EAEF
      margin-right 8px
    &-bottom
      width 355px
      height 84px
      // background pink
      position relative
    .skeleton-split-line
      position absolute 
      top 84px
      left 14px
      height 1px
      width 355px
      background #EEEEEE
    &-2
      position absolute 
      width 105px
      height 20px
      background #E4EAEF
      border-radius 6px
      top 34px
      left 14px
    &-3
      position absolute 
      width 40px
      height 40px
      background #FF6400
      border-radius 10px
      left 301px
      top 24px
    &-4
      position absolute 
      width 105px
      height 20px
      background #E4EAEF
      border-radius 6px
      left 14px
      top 114px
    &-5
      position absolute 
      width 40px
      height 40px
      background #FF6400
      border-radius 10px
      left 301px
      top 104px
  .seat-information
    &:not(:last-child)
      margin-bottom 10px
    &:last-child
      margin-bottom 5px
</style>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { xenv, query } from '@didi/webx-js'
  import { formatDate, getDayByOffset, compare } from '@didi/es-mpx-shared'
  import store from '@/store'
  import { getStorage, setStorage } from '@/utils/storage'
  import initMixin from '@/mixins'
  import { LOAD_FAIL_CONTENT } from '@/common/constant'
  import {
    STORAGE_LIST_SEARCH_QUERY,
    STORAGE_CURRENT_SELECTED_CITY,
    STORAGE_DETAIL_SEARCH_QUERY,
    STORAGE_CURRENT_TRAVEL
  } from '@/utils/train-storage'
  import Toast from '@didi/es-mpx-ui/lib/toast/functional'
  import { trackEvent } from '@/common/track'
  import { getPopList } from './components/privacy/api'
  import { innerRouter, pagePath } from '@/common/jump'
  import { getFinalPrice } from '@/utils/money'
  import { getFullDate } from '@didi/es-mpx-shared/lib/date'

  createPage({
    mixins: [initMixin],
    data: {
      navbarStyle: {
        // background: '#ffffff',
        'font-size': '18px',
        'font-weight': 400,
        color: '#000000'
      },
      esMainStyle: {
        background: 'transparent'
      },
      lowerDrawer: {
        height: '252px'
      },
      travelSystemVisible: false,
      showStayInfo: false,
      useBlankPage: false,
      blankImageUrl:
        'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png',
      blankContextTitle: '加载失败',
      blankContextSubTitle: LOAD_FAIL_CONTENT,
      hasButton: false,
      time: null,
      headerMaxDateTime: null,
      headerMinDateTime: null,
      // isOld: '',
      stayInfo: null,
      showTrainInfomation: false,
      linking: true,
      returnPre: true,
      from: '',
      showServiceDescription: false,
      privacyList: {},
      scene: 'customer_train', // 百川配置的业务场景
      caller: 'customer_train_toc', // 前端调用接口时自定义的独特id
      showPriceEstimation: false,
      priceEstimation: {
        title: '价格预估',
        detail: {}
      },
      curTrainNo: '',
    },
    onShow() {
      this.getCurrentUserReverse({ init: true })
      const trainListSearchQuery = getStorage(STORAGE_LIST_SEARCH_QUERY) || {}
      const val = new Date(trainListSearchQuery.train_date).getTime() || new Date().getTime()
      this.setTravelDate(val)
      this.timeChange(val)
      trackEvent('userteam_train_trainnum_sw', 'UT-火车票-车次详情-曝光', this.trackParams)
      if(this.trainDetailRefreshFlag) {
        trackEvent('', '排查--车次详情--onShow--getTrainDetailFunc执行')
        this.getTrainDetailFunc()
      }
    },
    computed: {
      ...store.mapState({
        changeOrderInfo: 'change.changeOrderInfo',
        trainInfo: 'train.trainInfo',
        selectSeatInfo: 'train.selectSeatInfo',
        ticketData: 'train.ticketData',
        trainDetailRefreshFlag: 'train.trainDetailRefreshFlag', // 刷新flag
        isTransfer: 'train.isTransfer' // 详情页不能用selectSeatInfo或者ticketData进行判断，因为后端接口可能会返回空导致标识出问题
      }),
      ...store.mapGetters({
        selectDate: 'travel.selectDate', // 存起来的出发时间
        limitDate: 'change.limitDate', // 限制时间
        travelInfo: 'travel.travelInfo' // 存起来的当前差旅
      }),
      showExemption(){
        return !this.fromChangeTicket && this.isHasSeat && !this.isPreScramble
      },
      token() {
        return getStorage('token') || getStorage('userInfo')?.token
      },
      trainListSearchQuery() {
        return getStorage(STORAGE_LIST_SEARCH_QUERY)
      },
      selectCityList() {
        return getStorage(STORAGE_CURRENT_SELECTED_CITY)
      },
      fromChangeTicket() {
        return !!this.changeOrderInfo?.order_id
      },
      maxDateTime() {
        const _max = this.fromChangeTicket
          ? this.limitDate?.maxDate
          : this.limitDate?.maxDateForReserve
        return new Date(_max).getTime()
      },
      minDateTime() {
        return new Date(this.limitDate?.minDate).getTime()
      },
      disabled() {
        return !this.travelInfo
      },
      isStudent() {
        const STUDENT_CODE = 13
        const { passenger_type } = getStorage(STORAGE_LIST_SEARCH_QUERY)
        return passenger_type === STUDENT_CODE
      },
      trackParams() {
        const type = this.fromChangeTicket ? 'modify' : 'order'
        return { type }
      },
      appId() {
        const appidMap = {
          alimp: 35023,
          wxmp: 35009,
          passenger: 10000,
          // h5: 10000,
        }
        return appidMap[xenv()]
      },
      isHasSeat(){
        return this.isTransfer || this.selectSeatInfo[0]?.ticket_num !== '无票'
      },
      isPreScramble(){
        return this.trainInfo?.pre_scrambl_flag === 1 
      },
      cardType(){
        return this.isPreScramble 
          ? 3 
          : (this.isHasSeat || this.fromChangeTicket) 
            ? 0 
            : 2
      },
      stayInfoList() {
        const list = this.trainInfo?.transfer_ticket?.map(item=>{
          return {
            train_date: formatDate(item?.start_time),
            train_code: item?.train_code || '',
            train_no: item?.train_no || '',
            from_station_name: item?.from_station_name || '',
            to_station_name: item?.to_station_name || '',
          }
        })
        return list || []
      },
    },
    methods: {
      ...store.mapActions({
        getTrainDetail: 'train.getTrainDetail',
        getCurrentUserReverse: 'login12306.getCurrentUserReverse'
      }),
      ...store.mapMutations({
        setTravelDate: 'travel.setTravelDate',
        setSelectSeatInfo: 'train.setSelectSeatInfo',
        setTrainDetailRefreshFlag: 'train.setTrainDetailRefreshFlag'
      }),
      jumpFn() {
        innerRouter.push(pagePath().ICKETPURCHASENOTICE)
      },
      setShowRuleDetail() {
        this.travelSystemVisible = false
      },
      closeSSI() {
        this.showStayInfo = false
      },
      showSSI(e) {
        const trainDetail = e?.detail || {}
        const train_code = trainDetail?.train_code || ''
        const train_no = trainDetail?.train_no || ''
        const info = {
          train_date: formatDate(trainDetail?.start_time),
          train_code: train_code,
          train_no: train_no,
          from_station_name: trainDetail?.from_station_name || '',
          to_station_name: trainDetail?.to_station_name || '',
        }
        this.stayInfo = info
        this.showStayInfo = true
      },
      /**
       * @method 获取车次列表
       */
      getTrainDetailFunc() {
        trackEvent('', '排查--车次详情--getTrainDetailFunc--执行')
        this.useBlankPage = false
        this.showTrainInfomation = false
        this.getTrainDetail(this.trainDetailParams())
          .then((res) => {
            trackEvent('', '排查--车次详情--getTrainDetailFunc--返回', res)
            mpx.hideLoading()
            const { code, data, message, success } = res || {}
            if (success) {
              this.showTrainInfomation = true
              if (
                code === '0' &&
                data?.from_station_name &&
                data?.to_station_name
              ) {
                this.useBlankPage = false
                this.blankImageUrl = null
                this.blankContextTitle = ''
                this.blankContextSubTitle = ''
                this.hasButton = false
              } else {
                this.useBlankPage = true
                this.blankImageUrl =
                  'https://pt-starimg.didistatic.com/static/starimg/img/Ot7ziDz0Oc1645096142894.png' // 空数据
                this.blankContextTitle = '当天没有该车次'
                this.blankContextSubTitle = '换个时间再试试'
                this.hasButton = false
                trackEvent('userteam_train_trainnum_noresult_sw', 'UT-火车票-首页-车次详情无结果-曝光', this.trackParams)
              }
            } else {
              this.useBlankPage = true
              this.blankImageUrl =
                'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png'
              this.blankContextTitle = '加载失败'
              this.blankContextSubTitle = LOAD_FAIL_CONTENT
              this.hasButton = true
              Toast({
                message: '车票查询失败',
                overlay: false,
                duration: 3000
              })
              return
            }
          })
          .catch((e) => {
            mpx.hideLoading()
            console.log('error', e)
          })
          .finally(() => {
            mpx.hideLoading()
          })
      },
      timeChange(val) {
        this.time = [val]

        const flag1 = this.maxDateTime - val < 604800000
        this.headerMaxDateTime = flag1 ? this.maxDateTime : ''
        const flag2 = val - this.minDateTime < 604800000
        this.headerMinDateTime = flag2 ? this.minDateTime : ''
      },
      changeDate(data) {
        const date = new Date(data?.[0]).setHours(8)
        // 车次列表搜索参数更新
        let searchQuery = getStorage(STORAGE_LIST_SEARCH_QUERY)
        const compareTime = compare(getDayByOffset(Date.now(), 59).getTime(), date)
        if (compareTime >= 0) {
          if (
            formatDate(date, 'YYYY-MM-dd') !== searchQuery?.train_date &&
            date <= this.maxDateTime &&
            date >= this.minDateTime
          ) {
            // 选中日期保存更新
            this.setTravelDate(date)
            searchQuery = {
              ...searchQuery,
              train_date: formatDate(date, 'YYYY-MM-dd')
            }
            setStorage({ key: STORAGE_LIST_SEARCH_QUERY, data: searchQuery })

            this.getTrainDetailFunc()
          }
        } else {
          Toast({
            message: '您所选择的日期列车暂未开售，请选择其他日期',
            overlay: false
          })
          if (this.returnPre) {
            this.$refs?.__mpx_ref_date_card__?.returnToPre?.() // 小程序
            this.$refs?.date_card?.returnToPre?.() // h5
          } else {
            this.$refs?.__mpx_ref_date_card__?.returnToPre?.() // 小程序
            this.$refs?.date_card?.returnToPre?.() // h5
            this.linking = false
            setTimeout(() => {
              this.linking = true
            }, 500)
          }
        }
        this.returnPre = true
      },
      onConfirm(data) {
        this.returnPre = false
        this.changeDate.call(this, data.detail)
      },
      async handleClickDay(data) {
        this.changeDate.call(this, data.detail.data)
      },
      getServiceDescription() {
        this.showServiceDescription = true
      },
      closeServiceDescription() {
        this.showServiceDescription = false
      },
      buyClickReport({ detail }) {
        const is_exemption = detail === 1
        const is_scramble = detail === 2
        const event_id = is_exemption
          ? 'userteam_train_trainnum_quick_ck'
          : 'userteam_train_trainnum_order_ck'
        const event_name = is_exemption
          ? 'UT-火车票-车次详情-快捷免登-点击'
          : 'UT-火车票-车次详情-预定/抢票-点击'
        if (is_scramble)
          trackEvent(event_id, event_name, {
            ...this.trackParams,
            type: 'snatch',
          })
        else
          trackEvent(event_id, event_name, {
            ...this.trackParams,
            login_type: is_exemption ? 'quick' : '12306',
          })
      },
      seatInfoClickReport(params) {
        const module = params?.detail
        trackEvent('userteam_train_trainnum_ticket_ck', 'UT-火车票-车次详情-票模块-点击', {
          ...this.trackParams,
          module
        })
      },
      dateCardClickReport(params) {
        const module = params?.detail
        trackEvent('userteam_train_trainnum_date_ck', 'UT-火车票-车次详情-日期模块-点击', {
          ...this.trackParams,
          module
        })
      },
      goBackReport() {
        trackEvent('userteam_train_trainnum_return_ck', 'UT-火车票-车次详情-返回-点击', this.trackParams)
      },
      resetPrivacyList() {
        this.privacyList = {}
      },
      async getPopList() {
        // 获取未签署协议列表
        const params = {
          appid: this.appId,
          caller: this.caller,
          token: this.token,
        }
        try {
          const { data } = await getPopList(params)
          if (data && data.scene_map && data.doc_map) {
            const { scene_map, doc_map } = data
            this.privacyList = doc_map[scene_map[this.scene]] || {}
          }
        } catch (error) {
          console.error(error)
        }
      },
      // 卧票价格具体信息相关
      openPriceEstimation({ detail }) {
        const {
          seat_type_name,
          seatS_ticket_price,
          seatX_ticket_price,
          seatZ_ticket_price
        } = detail
        const seats = [
          {
            name: '上铺',
            value: seatS_ticket_price,
          },
          {
            name: '中铺',
            value: seatZ_ticket_price,
          },
          {
            name: '下铺',
            value: seatX_ticket_price,
          },
        ].filter(({value}) => value)
        this.priceEstimation = {
          title: `${seat_type_name}价格预估`,
          detail: {
            fee_info: [{
              fee_item: seats.map(({name, value}) => {
                return {
                  name: `${seat_type_name}${name}`,
                  value: `¥ ${getFinalPrice(value) || 0}`,
                  bold: true,
                  pixel: '14px',
                  color: '#333333',
                }
              })
            }]
          }
        }
        this.showPriceEstimation = true
      },
      closePriceEstimation() {
        this.showPriceEstimation = false
      },
      setStayInfo(e) {
        this.stayInfo = e?.detail ?? {}
      },
      getDays(timeStamp, canCheck) {
        const weeks = ['日', '一', '二', '三', '四', '五', '六']
        const { week, day } = getFullDate(timeStamp)
        const item = {
          canCheck,
          timeStamp,
          weekText: '周' + weeks[week],
          dateText: formatDate(timeStamp, 'M月d日')
        }
        return item
      },
      trainDetailParams() {
        const { train_date, booking_type, start_time_list } = getStorage(STORAGE_LIST_SEARCH_QUERY)
        const { train_no, train_code, from_station_name, to_station_name, transfer_ticket, transfer_stop_time, transfer_station_city_name } = getStorage(
          STORAGE_DETAIL_SEARCH_QUERY
        )
        trackEvent('', '排查--车次详情--trainDetailParams--选择城市上报', this.selectCityList)
        const from_city_id = this.selectCityList?.[0]?.id
        const to_city_id = this.selectCityList?.[1]?.id
        const startTime = JSON.parse(start_time_list)[0] || '00:00:00'
        const start_date_time = train_date + ' ' + startTime
        //改签为1 下单为0
        const is_change_ticket = this.fromChangeTicket ? 1 : 0
        const { passenger_type } = getStorage(STORAGE_LIST_SEARCH_QUERY)
        const union_type = (this.isTransfer && !this.fromChangeTicket)  ? 1 : 0
        const train_nos = JSON.stringify(transfer_ticket?.map(item => item.train_no) ?? [])
        const train_codes = JSON.stringify(transfer_ticket?.map(item => item.train_code) ?? [])
        const from_station_names = JSON.stringify(transfer_ticket?.map(item => item.from_station_name) ?? [])
        const to_station_names = JSON.stringify(transfer_ticket?.map(item => item.to_station_name) ?? [])
        const from_station_nos = JSON.stringify(transfer_ticket?.map(item => item.from_station_no) ?? [])
        const to_station_nos = JSON.stringify(transfer_ticket?.map(item => item.to_station_no) ?? [])
        const train_secrets = JSON.stringify(transfer_ticket?.map(item => item.train_secrets) ?? [])
        return {
          start_time: start_date_time,
          from_station_name,
          to_station_name,
          train_no,
          train_code,
          from_city_id,
          to_city_id,
          booking_type,
          is_change_ticket,
          passenger_type,
          union_type,
          train_nos,
          train_codes,
          from_station_names,
          to_station_names,
          from_station_nos,
          to_station_nos,
          train_secrets,
          transfer_stop_time,
          transfer_station_city_name
        }
      },
    },
    watch: {
      selectDate: {
        immediate: true,
        deep: true,
        handler(val) {
          if (!this.time) {
            this.timeChange(val)
          }
        }
      }
    },
    onUnload() {
      this.setSelectSeatInfo([])
    },
    mounted() {
      const query = this.$mpxRoute?.query
      // this.isOld = query.old_progress
      this.from = query?.from
      const trainListSearchQuery = getStorage(STORAGE_LIST_SEARCH_QUERY) || {}
      const { trainInfo } = this
      this.showTrainInfomation = true
      trackEvent('', '排查--车次详情--mounted执行')
      this.setTrainDetailRefreshFlag(false)
      this.getTrainDetailFunc()
      this.getPopList()
      let _str = ''
      for (let o in query) {
        _str += o + '=' + query[o] + '&'
      }
      const str = _str ? `?${_str.substring(0, _str.length - 1)}` : ''
      const fullPath = `/${this.$mpxRoute.path}${str}`
      // 时间处理
      const val = new Date(trainListSearchQuery.train_date).getTime() || new Date().getTime()
      this.setTravelDate(val)
      this.timeChange(val)
      const date = new Date(val).setHours(8)
      let searchQuery = getStorage(STORAGE_LIST_SEARCH_QUERY)
      mpx.setNavigationBarColor({ frontColor: '#000000' })
    }
  })
</script>

<script name="json">
  module.exports = {
    usingComponents: {
      'seat-information': './components/seat-information',
      'stay-info-drawer': '@/components/stay-info-drawer',
      'train-information-new': '@/components/train-information-new',
      'date-card': './components/date-card',
      'drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom',
      'buy-ticket-card': './components/buy-ticket-card',
      'nologin-description': './components/nologin-description',
      'es-toast': '@didi/es-mpx-ui/lib/toast',
      'change-navbar': '@/components/change-navbar',
      'price-detail-info-alter': '@/components/price-detail-info-alter',
      'guide-tips':'../search/components/guide-tips',
      'transfer-info-tip': '@/components/transfer-info-tip'
    }
  }
</script>
